import styled from 'styled-components'

export const TabsContainer = styled.div`
    .react-tabs__tab-list {
        display: flex;
        padding: 0;
        list-style-type: none;
        margin-bottom: 1rem;
        flex-wrap: wrap;
    }

    .react-tabs__tab {
        display: inline-block;
        padding: 5px 0;
        border-bottom: 2px solid transparent;
        margin-right: 1.5rem;
        font-weight: 500;
        cursor: pointer;
    }

    .react-tabs__tab--selected {
        color: ${props => props.theme.admin.colors.brand};
        border-bottom-color: ${props => props.theme.admin.colors.brand};
    }
`

export const StyledList = styled.ul`
    padding-left: 1rem;

    li {
        position: relative;
        list-style-type: none;
        margin-bottom: 10px;

        &:before {
            content: '';
            height: 8px;
            width: 8px;
            background-color: ${props => props.theme.admin.colors.brand};
            display: inline-block;
            position: absolute;
            left: -15px;
            top: 6px;
            border-radius: 50%;
        }
    }
`
